import { Divider, Grid, Typography } from "@material-ui/core";
import "react-nice-dates/build/style.css";
import Loading from "../../../components/basics/Loading";

import HeaderModule from "../../../components/header/HeaderModule";

import { useEffect, useState } from "react";
import MaskService from "../../../utils/mask/maskService";
import {
  Filter,
  ReportActions,
  ReportFooter,
  ReportHeader,
  ReportTable,
} from "./children";
import { FluxoCaixaProvider, useFluxoDeCaixaService } from "./contexts";

const View = () => {
  const {
    filters,
    columns,
    cachedMovimentData,
    cachedPreviousBalance,
    cashLoading,
    isRefetching,
  } = useFluxoDeCaixaService();

  const [isConsolidated, setIsConsolidated] = useState(false);

  useEffect(() => {
    const consolidated = cachedMovimentData.every(
      (moviment) => !moviment.accounts?.length
    );
    setIsConsolidated(consolidated);
  }, [cachedMovimentData, filters.reportType]);

  return (
    <>
      <HeaderModule title="FLUXO DE CAIXA" />
      <Loading open={cashLoading || isRefetching} />
      <Grid
        container
        direction="column"
        style={{ marginTop: 80, padding: "0px 16px" }}
        spacing={2}
      >
        <Filter />

        {filters.showPreviousBalance && (
          <>
            <Grid item container>
              <Grid item xs={12}>
                <Typography variant="h4">Saldo anterior</Typography>
              </Grid>
              <Grid item container xs spacing={2}>
                {cachedPreviousBalance?.companies?.map((company) => (
                  <Grid
                    item
                    container
                    xs={4}
                    direction="column"
                    key={company.fantasy}
                  >
                    <Grid item style={{ margin: "16px 0 8px 0" }}>
                      <Typography variant="h5">{company.fantasy}</Typography>
                    </Grid>
                    {company?.agencies.map((agency) => (
                      <Grid
                        item
                        key={`${agency.description}-${agency.balance}`}
                      >
                        <Typography>
                          &ndash; {agency.description}:{" "}
                          {agency.balance < 0 ? (
                            <Typography
                              style={{ fontWeight: "bold", color: "red" }}
                              variant="button"
                            >
                              (-){" "}
                              {MaskService.toMask(
                                "decimal",
                                parseFloat(agency.balance * -1).toFixed(2),
                                2
                              )}
                            </Typography>
                          ) : (
                            <Typography
                              style={{ fontWeight: "bold", color: "green" }}
                              variant="button"
                            >
                              (+) R${" "}
                              {MaskService.toMask(
                                "decimal",
                                parseFloat(agency.balance).toFixed(2),
                                2
                              )}
                            </Typography>
                          )}
                        </Typography>
                      </Grid>
                    ))}
                  </Grid>
                ))}
                <Grid
                  item
                  xs={12}
                  style={{ marginTop: 32, backgroundColor: "#d9edf7" }}
                  container
                  spacing={2}
                >
                  <Grid item>
                    <Typography variant="h6"> Saldo inicial total: </Typography>
                  </Grid>
                  <Grid item>
                    <Typography
                      style={{
                        fontWeight: "bold",
                        color:
                          cachedPreviousBalance?.totals < 0 ? "red" : "green",
                      }}
                      variant="h6"
                    >
                      {parseFloat(
                        cachedPreviousBalance?.totals ?? "0"
                      ).toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                        minimumFractionDigits: 2,
                      })}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </>
        )}

        <ReportHeader
          reportType={isConsolidated ? "Consolidado" : "Detalhado"}
        />
        <ReportActions />
        <Divider />

        <Grid item xs>
          <ReportTable
            data={cachedMovimentData}
            emptyMessage="Sem Movimentação"
            columns={columns}
            isConsolidated={isConsolidated}
          />
        </Grid>
        <Divider />

        <ReportFooter />
      </Grid>
    </>
  );
};

const FluxoDeCaixa = (props) => (
  <FluxoCaixaProvider>
    <View {...props} />
  </FluxoCaixaProvider>
);

export default FluxoDeCaixa;
